<ng-template #maskedPhone let-diallingCode="diallingCode" let-phone="phone" let-mask="mask">
  @if (phone && mask && ableToMask(phone, mask)) {
    {{ diallingCode }} {{ phone | mask: mask }}
  } @else if (phone) {
    {{ diallingCode }} {{ phone }}
  } @else {
    ---
  }
</ng-template>

<div class="address-card {{ containerClass }}">
  <p>{{ card?.address?.companyName }}</p>
  <p>{{ card?.address?.formattedAddress }}</p>

  @if (card?.address?.phone) {
    <p>
      <ng-container
        *ngTemplateOutlet="
          maskedPhone;
          context: { diallingCode: card.address?.country?.diallingCode, phone: card.address.phone, mask: card.address.country?.phoneMask }
        "
      >
      </ng-container>
    </p>
  }

  @if (showAddressTypeIcon) {
    <address-type-icon [address]="card.address"></address-type-icon>
  }
</div>
